const NotFound = resolve => {
  require.ensure(['./components/NotFound.vue'], () => {
    resolve(require('./components/NotFound.vue'));
  });
};

const MTNNotFound = resolve => {
  require.ensure(['./components/v2/mtn/NotFound.vue'], () => {
    resolve(require('./components/v2/mtn/NotFound.vue'));
  });
};



const Popup = resolve => {
  require.ensure(['./components/Popup.vue'], () => {
    resolve(require('./components/Popup.vue'));
  });
};


const Warning = resolve => {
  require.ensure(['./components/Warning.vue'], () => {
    resolve(require('./components/Warning.vue'));
  });
};


const v2Popup = resolve => {
  require.ensure(['./components/v2/Popup.vue'], () => {
    resolve(require('./components/v2/Popup.vue'));
  });
};

/* const PopupSelector = resolve => {
  require.ensure(['./components/v2/PopupSelector.vue'], () => {
    resolve(require('./components/v2/PopupSelector.vue'));
  });
}; */

const v2Warning = resolve => {
  require.ensure(['./components/v2/Warning.vue'], () => {
    resolve(require('./components/v2/Warning.vue'));
  });
};

const MTNPopup = resolve => {
  require.ensure(['./components/v2/mtn/MTNPopup.vue'], () => {
    resolve(require('./components/v2/mtn/MTNPopup.vue'));
  });
};

const v2MTNWarning = resolve => {
  require.ensure(['./components/v2/mtn/Warning.vue'], () => {
    resolve(require('./components/v2/mtn/Warning.vue'));
  });
};


const v2Timeout = resolve => {
  require.ensure(['./components/v2/SessionTimeout.vue'], () => {
    resolve(require('./components/v2/SessionTimeout.vue'));
  });
};





const routes = [{
    path: '/popup',
    name: 'popup',
    component: Popup,
    meta: {
      description: '',
      title: 'OnePipe Checkout Version 1'
    },
  },
  {
    path: '/v2/popup',
    name: 'popup-v2',
    component: v2Popup,
    props: true,
    meta: {
      description: '',
      title: 'Selector'
    },
  },

  {
    path: '/warning',
    name: 'warning',
    component: Warning,
    meta: {
      description: 'This is for invalid transaction',
      title: 'Warning'
    },
  },
  {
    path: '/v2/warning',
    name: 'warning-v2',
    component: v2Warning,
    meta: {
      description: 'This is for invalid transaction',
      title: 'Warning'
    },
  },
  {
    path: '/v2/mtn/popup',
    name: 'mtn-popup-v2',
    component: MTNPopup,
    props: true,
    meta: {
      description: '',
      title: 'Selector'
    },
  },

  {
    path: '/v2/mtn/warning',
    name: 'mtn-warning-v2',
    component: v2MTNWarning,
    meta: {
      description: 'Failed Transaction',
      title: 'Warning'
    },
  },


  {
    path: '/v2/timeout',
    name: 'timeout-v2',
    component: v2Timeout,
    meta: {
      description: 'Session timeout. You were idle',
      title: 'Warning'
    },
  },

  {
    path: '*',
    name: 'notfound',
    component: window.location.hostname.includes('mtn-ui') ? MTNNotFound : NotFound,
    meta: {
      description: 'The Page you\'re looking for is not found on this server',
      title: 'Page not Found'
    },
  },
];

export default routes;